var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarHalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.56 0 5.914 5.36 0 6.218l4.28 4.172-1.01 5.89L8.56 13.5V0Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m8.56 0 2.645 5.36 5.914.859-4.28 4.172 1.01 5.89L8.56 13.5V0Z",
  fill: "#707070"
})));
export { SvgStarHalf as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC41NTk1MSAwTDUuOTE0NDggNS4zNTk0MkwwIDYuMjE4ODVMNC4yNzk3NiAxMC4zOTA2TDMuMjY5NDQgMTYuMjgxMkw4LjU1OTUxIDEzLjVWMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC41NTk2MyAwTDExLjIwNDcgNS4zNTk0MkwxNy4xMTkxIDYuMjE4ODVMMTIuODM5NCAxMC4zOTA2TDEzLjg0OTcgMTYuMjgxMkw4LjU1OTYzIDEzLjVWMFoiIGZpbGw9IiM3MDcwNzAiIC8+Cjwvc3ZnPgogICAg";